<div class="search-container" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20">
  <input class="custom-search-box" type="text" placeholder="Search Events" [(ngModel)]="searchText" (input)="applySearchFilter()">
</div>

<div class="container">
  <table class="events-table">
    <tbody>
      <tr>
        <th>Event ID</th>
        <th>Date & Time</th>
        <th>Event Type<span class="badge">{{totalCount}}</span></th>   
        <th>Device ID</th>
        <th>User</th>
        <!-- <th>Location</th> -->
        <th>Resolved By</th>      
      </tr>
      <tr *ngFor="let event of events">
        <td>{{ event?.id }}</td>
        <td>{{ event?.created_time | date: 'medium' }}</td>
        <td>{{ capitalizeFirstLetter(event?.event_type) }}<span *ngIf="event?.capture_type"> - {{ capitalizeFirstLetter(event?.capture_type) }}</span> </td>
         <td><a [routerLink]="'/device-details/locationId/' + LocationID + '/device/' + event?.device_id">{{ event?.device_id }}</a></td>        
        <td>{{ capitalizeFirstLetter(event?.user_name) }}</td>
        <td>{{ event?.resolved_by }}</td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
</div>

<div class="pagination-controls" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="pagination" fxFlexAlign="center center">
    <button class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
    <span class="page-button">Page {{ currentPage }} of {{ totalPages > 1 ? totalPages : 1 }}</span>
    <button class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === (totalPages > 1 ? totalPages : 1)">Next</button>
  </div>
  <div class="items">
    <mat-form-field appearance="outline" class="pagination-mat-form-field">
      <mat-select [placeholder]="defaultPlaceholder" [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)">
        <mat-option value="5">5</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="15">15</mat-option>
        <mat-option value="20">20</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
